import { SideContext } from '@/App';
import { SideStatus } from '@/commons/context/side-store';
import { graphicStore } from '@/commons/store/graphic-store';
import { SIDE_TYPE } from '@/commons/enums/side-type';
import { useContext } from 'react';

import { ReactComponent as CameraSvg } from '@/commons/icons/monitoring/camera.svg';
import { ReactComponent as AnemoclinographSvg } from '@/commons/icons/monitoring/anemoclinograph.svg';
import { ReactComponent as MaintLevelGaugeSvg } from '@/commons/icons/monitoring/maint-level-gauge.svg';
import { ReactComponent as DvrSvg } from '@/commons/icons/monitoring/dvr.svg';
import { ReactComponent as SerialSvg } from '@/commons/icons/monitoring/serial.svg';
import { ReactComponent as DataWireSvg } from '@/commons/icons/monitoring/data-wire.svg';
import { ReactComponent as XungengdianSvg } from '@/commons/icons/new/xungengdain.svg';
import { ReactComponent as ShexiangtouSvg } from '@/commons/icons/new/shexiangtou.svg';

import { ReactComponent as ChuankoushebeiSvg } from '@/commons/icons/menu/maint/chuankoushebei.svg';
import { ReactComponent as FengsufengxiangyiSvg } from '@/commons/icons/menu/maint/fengsufengxiangyi.svg';
import { ReactComponent as JianchajiluSvg } from '@/commons/icons/menu/maint/jianchajilu.svg';
import { ReactComponent as JianchalujingSvg } from '@/commons/icons/menu/maint/jianchalujing.svg';
import { ReactComponent as ShuiweijiSvg } from '@/commons/icons/menu/maint/shuiweiji.svg';
import { ReactComponent as XinshexiangtouSvg } from '@/commons/icons/menu/maint/xinshexiangtou.svg';
import { ReactComponent as YingpanjiekouSvg } from '@/commons/icons/menu/maint/yingpanjiekou.svg';

export default function MaintMenu() {
    const sideContext = useContext<SideStatus>(SideContext);

    const onClick = (route: string) => {
        graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
        sideContext.setSelectedPanelValue(route);
    }

    return (
        <div className='tn-menu-container'>
            <div className='ope-panel'>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.patrol_point) }}>
                                <div className='icon'><XungengdianSvg /></div>
                                <div className='name'>巡更点</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><JianchalujingSvg /></div>
                                <div className='name'>巡检路径</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><JianchajiluSvg /></div>
                                <div className='name'>巡检记录</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name5' onClick={() => { onClick(SIDE_TYPE.monitor) }}>
                                <div className='icon'><ShexiangtouSvg /></div>
                                <div className='name'>巡检摄像头</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.camera) }}>
                                <div className='icon'><XinshexiangtouSvg /></div>
                                <div className='name'>摄像头</div>
                            </div>
                            <div className='ope-item name5' onClick={() => { onClick(SIDE_TYPE.anemoclinograph) }}>
                                <div className='icon'><FengsufengxiangyiSvg /></div>
                                <div className='name'>风速风向仪</div>
                            </div>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.water_level_gauge) }}>
                                <div className='icon'><ShuiweijiSvg /></div>
                                <div className='name'>水位计</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name5' onClick={() => { onClick(SIDE_TYPE.dvr) }}>
                                <div className='icon'><YingpanjiekouSvg /></div>
                                <div className='name'>硬盘录像机</div>
                            </div>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.serial_device) }}>
                                <div className='icon'><ChuankoushebeiSvg /></div>
                                <div className='name'>串口设备</div>
                            </div>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.cable) }}>
                                <div className='icon'><DataWireSvg /></div>
                                <div className='name'>数据线</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}